import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { useI18blogTabs } from "../../../../../hooks";

import { BoxWrapper } from "../../../../../components";
import { IconSprite } from "../../../../../components/ui/IconSprite/IconSprite";
import { addStyles } from "./addStyles";

import {
  Date,
  DateContainer,
  Label,
  LabelContainer,
  Title,
} from "./ArticleHeading.styled";

export const ArticleHeading = ({ main, title, tab, date }) => {
  const { t } = useTranslation();

  const { tabs } = useI18blogTabs();

  const getTabTitle = useMemo(
    () => tabName => {
      // const tabInfo = t("blog.tabs", { returnObjects: true }).find(
      //   item => item.name === tabName,
      // );
      const tabInfo = tabs.find(item => item.name === tabName);
      // return tabInfo ? tabInfo.title : t("blog.tabs.placeholder.title");
      return tabInfo ? tabInfo.title : t("blog.tabs.title.5");
    },
    [t, tabs],
  );

  return (
    <BoxWrapper addStyles={addStyles} main={main}>
      <LabelContainer>
        <Label
          label={getTabTitle(tab || "placeholder") || ""}
          color="primary"
        />
      </LabelContainer>

      <DateContainer>
        <Date
          label={date}
          icon={<IconSprite tag="calendar" width="24" height="24" />}
        />
      </DateContainer>

      <Title variant="h2">{title}</Title>
    </BoxWrapper>
  );
};
